import { connect } from 'react-redux';
import { getProfileOwnerUser } from '../../../selectors/users';
import { getShopItemsStreamId } from '../../../streams/shop';
import { ShopItemType } from '../../../../types/shop';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';

export default connect(state => {
  const commissionsTotal = streamSelectors.getTotal(
    state,
    getShopItemsStreamId(ShopItemType.COMMISSIONS)
  );
  const premiumContentTotal = streamSelectors.getTotal(
    state,
    getShopItemsStreamId(ShopItemType.PREMIUM_CONTENT)
  );
  const printsTotal = streamSelectors.getTotal(
    state,
    getShopItemsStreamId(ShopItemType.PRINTS)
  );

  const allTotal = commissionsTotal + printsTotal + premiumContentTotal;

  return {
    profileOwnerUser: getProfileOwnerUser(state),
    total: {
      all: isNaN(allTotal) ? undefined : allTotal,
      commissions: commissionsTotal,
      premiumContent: premiumContentTotal,
      prints: printsTotal,
    },
  };
});
